<template>
  <!-- Modal close -->
  <div
    class="w-full h-screen bg-transparent absolute top-0 left-0 right-0 z-40 cursor-default"
    v-show="(comboardModal || detailModal || deleteModal || recipientsModal)"
    @click="comboardModal = false, detailModal = false, deleteModal = false, recipientsModal = false">
  </div>

  <!-- Recipients Modal -->
  <vue-final-modal
    v-model="recipientsModal"
    classes="flex justify-center items-center"
    :ssr="true"
    content-class="relative h-5/6 flex flex-col mx-4 md:mx-0 pt-2 pb-4 border dark:border-gray-600 rounded bg-white dark:bg-gray-900 w-11/12 md:w-4/5 lg:w-1/2"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t','tr','r','br','b','bl','l','tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
  <jb-button
        class="absolute top-1 right-1 z-20 rounded-lg md:rounded dark:bg-gray-800 dark:text-white dark:border-gray-700"
        @click="recipientsModal = false"
        :icon="mdiClose">
    </jb-button>
    <div class="grow overflow-y-auto">
      <recipients-form
        :prop-comboards="recipientsObject"
        :prop-child="recipientsObject"
        @close-modal="hideModalRecipients"
        @click-refresh="refresh()"
      >
      </recipients-form>
    </div>
  </vue-final-modal>

  <!-- Form Modal -->
  <vue-final-modal
    v-model="comboardModal"
    classes="base-modal"
    :ssr="true"
    :content-class="darkMode ? 'add-modal bg-darkmode-base transition-colors duration-1000' : 'add-modal bg-white transition-colors duration-1000'"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1 v-if="showEdit">{{ $t('comboard.editcomboard') }}</h1>
      <h1 v-else>{{ $t('comboard.addcomboard') }}</h1>

      <jb-button
        class="btn-close-modal"
        :icon="mdiClose"
        @click="comboardModal = false" />
    </div>

    <!-- Modal content -->
    <div class="modal-content">
      <comboard-form
        :prop-class="comboardObject"
        :show-edit="showEdit"
        @close-modal="hideModalComboard"
        @show-modal="showDetail"
        @click-refresh="refresh()"
      />
    </div>
  </vue-final-modal>

  <!-- Detail Modal -->
  <vue-final-modal
    v-model="detailModal"
    classes="base-modal"
    :ssr="true"
    content-class="add-modal bg-gray-100 dark:bg-gray-700 transition-colors duration-1000"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false" transition="vfm" overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false" drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>{{ $t('comboard.detailcomboard') }}</h1>

      <jb-button
        class="btn-close-modal"
        :icon="mdiClose"
        @click="detailModal = false" />
    </div>

    <div class="modal-content detail-content">
      <comboard-detail
        :prop-class="comboardObject"
        @close-modal="hideModalComboard"
        @click-refresh="refresh()"
      />
    </div>
  </vue-final-modal>

  <!-- Delete Modal -->
  <vue-final-modal
    v-model="deleteModal"
    classes="base-modal"
    :ssr="true"
    :content-class="darkMode ? 'delete-modal bg-darkmode-base transition-colors duration-1000' : 'delete-modal bg-gray-100 transition-colors duration-1000'"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>{{ $t('menu.delete') }} {{ $t('menu.data') }}</h1>

      <jb-button class="btn-close-modal" :icon="mdiClose" @click="deleteModal = false" />
    </div>

    <!-- Modal content -->
    <div class="delete-content">
      <div class="warning">{{ $t('menu.warning') }}</div>

      <div class="messsage"><p>{{ $t('confirmDelete.message') }}</p></div>
    </div>

    <!-- Button action -->
    <div class="buttons-submit transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'">
      <jb-buttons class="buttons-action-submit">
        <jb-button :label="$t('finance.button.btnConfirm')" color="info" :icon="mdiTrashCan" @click="confirm" class="form-submit-btn" />
        <jb-button :label="$t('finance.button.btnCancel')" outline @click="cancel" class="btn-reset form-noicon-btn" />
      </jb-buttons>
    </div>
  </vue-final-modal>

  <div class="admin-comboard-container">
    <!-- Header comboard container -->
    <div class="header-container-comboard">
      <div class="space-header" />

      <div class="title-header">
        <p>Academic Comboard</p>
      </div>

      <div class="buttons-header">
        <button class="button-all-action button-all-secondary" v-if="loadingComboard === false" @click="addComboard()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/>
          </svg>
          <span>Add</span>
        </button>
      </div>
    </div>

    <!-- Comboard container -->
    <div class="comboard-container">
      <!-- Button show filter (mobile) -->
      <div class="button-show-filter" v-if="loadingComboard === false" @click="showMobFilter()" :class="mobFilter === true ? 'button-show-filter-act' : ''">
        Filter
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"/>
        </svg>
      </div>

      <!-- Filter content -->
      <div class="filter-content" :class="mobFilter === true ? 'mobile-filter-act' : 'mobile-filter-hide'">
        <!-- Search -->
        <div class="filter-component" v-if="loadingComboard === false">
          <p>Search</p>
          <input type="text" placeholder="Search" :icon="mdiArrowDownDropCircle" v-model="value.search">
        </div>

        <!-- Filter by year -->
        <div class="filter-component" v-if="loadingComboard === false">
          <p>Year</p>
          <datepicker v-model="filter.month" format="MM" :language="en" month-picker />
        </div>

        <!-- Filter by month -->
        <div class="filter-component" v-if="loadingComboard === false">
          <p>Month</p>
          <VueDatePicker v-model="filter.year" year-picker />
        </div>

        <!-- Filter by date -->
        <div class="filter-component" v-if="loadingComboard === false">
          <p>Date</p>
          <VueDatePicker v-model="filter.dates" format="MM/dd/yyyy" />
        </div>
      </div>

      <!-- Comboard content -->
      <div class="comboard-content">
        <!-- Comboard skelaton loading -->
        <div v-if="loadingComboard === true">
          <div class="comboard-skelaton-loading" v-for="data in 4" :key="data">
            <div class="loading-header">
              <div class="loading-bar loading-bar-big" />
              <div class="loading-bar" />
              <div class="loading-bar" />
            </div>

            <div class="loading-body">
              <div class="loading-container" />
              <div class="loading-container loading-container-big" />
            </div>
          </div>
        </div>

        <!-- Comboard card -->
        <div class="comboard-card" v-for="(item, index) in comboardData.value" :key="index">
          <!-- Header comboard -->
          <div class='header-comboard-card'>
            <!-- Header icon -->
            <div class="header-icon" @click="detailInfo(item.id)">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-if="item.is_recalled === true" :class="item.is_recalled === true ? 'danger-icon' : ''">
                <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-else>
                <path d="M96 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H80c-44.2 0-80-35.8-80-80V128c0-17.7 14.3-32 32-32s32 14.3 32 32V400c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm64 24v80c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"/>
              </svg>
            </div>

            <!-- Header information -->
            <div class="header-text" @click="detailInfo(item.id)">
              <!-- Title comboard -->
              <div class="title-comboard" :title="item.title">
                <p :class="item.is_recalled === true ? 'title-danger' : ''">{{ item.title }}</p>
              </div>

              <!-- Subtitle comboard -->
              <div class="subtitle-comboard">
                <p class="post-name">{{ item.creator }}</p>
                <p class="post-date">
                  {{ (item.datetime_1 ? formatShortDate(item.datetime_1) : '') }}
                  {{ (item.datetime_2 ? ' - ' + formatShortDate(item.datetime_2) : '') }}
                </p>
                <p class="post-recall" v-if="item.is_recalled === true" @click="showReason(item.id)">Recalled</p>
              </div>
            </div>

            <!-- Button action comboard -->
            <div
              class="action-comboard"
              v-if="(item.created_by === usernameLogin) || (checkUser === true)"
              :class="item.id && openPreAction[item.id.replace(/-/g, '')] ? 'open-action-comboard' : 'hide-action-comboard'"
            >
              <div class="action-comboard-navigation" @click="showActBtn(item.id)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 512">
                  <path d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"/>
                </svg>
              </div>

              <div class="action-comboard-button">
                <!-- Button add comboard -->
                <button class="button-all-action button-all-primary" @click="addRecipients(item, item.id)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/>
                  </svg>
                </button>

                <!-- Button edit comboard -->
                <button class="button-all-action button-all-secondary" @click="editData(item, item.id)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"/>
                  </svg>
                </button>

                <!-- Button detail comboard -->
                <button class="button-all-action button-all-success" @click="showDetail(item, item.id)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/>
                  </svg>
                </button>

                <!-- Button delete comboard -->
                <button class="button-all-action button-all-danger" @click="deletePost(item.id)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <!-- Content comboard -->
          <div class="content-comboard-card">
            <!-- Second title for mobile -->
            <div class="second-title">
              {{ item.title }}
            </div>

            <!-- Information comboard -->
            <div class="info-comboard" :class="(openText == item.id) ? 'open-info' : 'hide-info'">
              <span v-html="item.info" />

              <div class="show-info" @click="showText(item.id)">
                <p>{{ (openText == item.id) ? 'Less' : 'Show more' }}</p>
              </div>
            </div>

            <!-- Download file -->
            <div class="file-comboard" v-if="item.file_1.length != 0">
              <div class="file-container">
                <div class="file-content" v-for="file_data in item.file_1" :key="file_data" @click="download(file_data.file, '/download-comboard', item.id)" :title="file_data.file">
                  <div class="file-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                      <path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"/>
                    </svg>
                  </div>

                  <div class="file-name">
                    <p>{{ file_data.file }}</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Carousel video & photo -->
            <div class="carousel-comboard" v-if="(item.link_url != null )|| (item.link_url != undefined) || (item.file_img.length != 0)">
              <Carousel :mouse-drag="false" :touch-drag="false">
                <Slide v-if="(item.link_url != null ) || (item.link_url != undefined)">
                  <LazyYoutube
                    ref="youtubeLazyVideo"
                    :src="item.link_url"
                    thumbnail-quality="standard"
                  />
                </Slide>

                <Slide v-for="image in item.file_img" :key="image" v-show="(item.file_img.length != 0)">
                  <img :src="image" alt="Comboard picture">
                </Slide>

                <template #addons>
                  <Navigation/>
                  <Pagination/>
                </template>
              </Carousel>
            </div>
          </div>

          <!-- Comment Section -->
          <div class="comment-wrapper">
            <div class="mb-5">
              <span>Leave comment</span>
              <!-- <span class="look-comment">See Comments ({{ commentParent.value.filter(value => value.comboard_id === item.id).length + commentParent.value.filter(value => value.detail_id === value.id).length }}) </span> -->
            </div>

            <div class="h-0" v-if="commentParent.value.filter(value => value.comboard_id === item.id).length === 0"></div>

            <!-- Parent Comment -->
            <div class="scroll-comment" v-else>
              <li v-for="item_header in commentParent.value.filter(value => value.detail_id === null && value.comboard_id === item.id)" :key="item_header">
                <!-- Comment Container -->
                <div class="block-comment">
                  <span class="created-text">{{ item_header.name }}</span>
                  <span v-html="item_header.comment"></span>
                </div>

                <!-- Action Comment -->
                <div class="mb-2.5">
                  <div class="flex">
                    <span class="created_at">{{ item_header.created_at }}</span>
                    <span>.</span>
                    <span class="reply" @click="showid(item_header.id, item_header.reply)">Reply</span>

                    <!-- More Action Plus Comment For Delete -->
                    <div class="merge-container" @click="deletePostComment(item_header.id)" v-if="(item_header.created_by === usernameLogin) || (checkUser === true)">
                      <p class="dot">.</p>
                      <span class="text-delete">Delete</span>
                    </div>
                  </div>

                  <!-- Child Comment -->
                  <li v-for="item_head_detail in parentChild.value.filter(value => value.head_id === item_header.id)" :key="item_head_detail">
                    <div :style="'margin-left: '+(parseInt(item_head_detail.reply)-1)*30+'px;'">

                      <div class="flex">
                        <svg class="mr-2" width="15" height="35" viewBox="0 0 40 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <mask id="mask0_101_7" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="50">
                            <rect width="40" height="50" fill="#D9D9D9"/>
                          </mask>
                          <g mask="url(#mask0_101_7)">
                            <path d="M24 50L20.2667 45.8088L29.8 35.2941H0V0H5.33333V29.4118H29.8L20.2 18.8235L24 14.6324L40 32.3529L24 50Z" fill="black" fill-opacity="0.501961"/>
                          </g>
                        </svg>
                        <div class="block-comment">
                          <span class="created-text"> {{ item_head_detail.name }} </span>
                          <span>{{ item_head_detail.comment }}</span>
                        </div>
                      </div>

                      <!-- Action Comment -->
                      <div class="mb-2.5">
                        <div class="swipe">
                          <span class="created_at">{{ item_header.created_at }}</span>
                          <span>.</span>
                          <span class="reply" @click="showdetailid(item_head_detail.id, item_head_detail.reply, item_header.id)">Reply</span>

                          <!-- More Action Plus Comment For Delete -->
                          <div class="merge-container" @click="deletePostComment(item_head_detail.id)" v-if="(item_head_detail.created_by === usernameLogin) || (checkUser === true)">
                            <p class="dot">.</p>
                            <span class="text-delete">Delete</span>
                          </div>
                        </div>
                      </div>

                      <!-- Input Parent > Child First -->
                      <form @submit.prevent="store2(item_head_detail.id, item.id)" class="pb-3 pr-4 ml-7 z-10 dark:shadow-gray-200" v-if="comboards.show_detail_id===item_head_detail.id">
                        <div class="flex">
                          <svg class="mr-2" width="15" height="35" viewBox="0 0 40 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_101_7" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="50">
                              <rect width="40" height="50" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask0_101_7)">
                              <path d="M24 50L20.2667 45.8088L29.8 35.2941H0V0H5.33333V29.4118H29.8L20.2 18.8235L24 14.6324L40 32.3529L24 50Z" fill="black" fill-opacity="0.501961"/>
                            </g>
                          </svg>

                          <div class="reply-chat flex w-full">
                            <input class="input-comment" :key="index" v-model="parentChild.comment_detail[item_head_detail.id]">
                            <jb-button
                              :icon="mdiSend"
                              small
                              class="button-submit"
                              color="success"
                              type="submit"
                              id="submit">
                            </jb-button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </li>

                  <!-- Add Child Comment -->
                  <div v-if="comboards.show_id===item_header.id">
                    <!-- Input Parent > Child Second -->
                    <form @submit.prevent="store2(item_header.id, item.id)" class="pb-3 pr-4 z-10 dark:shadow-gray-200">
                      <div class="flex">
                        <svg class="mr-2" width="15" height="35" viewBox="0 0 40 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <mask id="mask0_101_7" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="50">
                            <rect width="40" height="50" fill="#D9D9D9"/>
                          </mask>
                          <g mask="url(#mask0_101_7)">
                            <path d="M24 50L20.2667 45.8088L29.8 35.2941H0V0H5.33333V29.4118H29.8L20.2 18.8235L24 14.6324L40 32.3529L24 50Z" fill="black" fill-opacity="0.501961"/>
                          </g>
                        </svg>

                        <div class="reply-chat flex w-full">
                          <input class="input-comment" :key="index" v-model="parentChild.comment_detail[item_header.id]">
                          <jb-button
                            :icon="mdiSend"
                            small
                            class="button-submit"
                            color="success"
                            type="submit"
                            id="submit">
                          </jb-button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </li>
            </div>

            <!-- Input Comment Parent -->
            <form @submit.prevent="store(item.id, indexx)" class="space-y-3 pb-3 z-10 dark:shadow-gray-200">
              <div>
                <textarea v-model="commentParent.comment_input[indexx]" :placeholder="'Type Your Comment On Here'" type="text"></textarea>
                <jb-button
                  label="Submit"
                  :icon="mdiSend"
                  small
                  class="button-submit"
                  color="success"
                  type="submit"
                  id="submit">
                </jb-button>
              </div>
            </form>
          </div>

        <!-- <div class="height-text"> -->
          <!-- <div class="flex items-center justify-center" v-if="item.is_recalled === true">
            <svg width="5" height="5" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0_2_32" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="10" height="10"><rect width="10" height="10" fill="#D9D9D9"/></mask>
              <g mask="url(#mask0_2_32)"><path d="M5.00288 8.98053C4.4536 8.98053 3.93733 8.87678 3.45406 8.66927C2.97079 8.46177 2.54792 8.17643 2.18544 7.81326C1.82296 7.4501 1.53801 7.02727 1.3306 6.54478C1.12318 6.0623 1.01947 5.54579 1.01947 4.99523C1.01947 4.44411 1.12322 3.92865 1.33073 3.44886C1.53824 2.96906 1.82357 2.54792 2.18674 2.18544C2.54991 1.82296 2.97273 1.53801 3.45522 1.3306C3.9377 1.12318 4.45422 1.01947 5.00477 1.01947C5.5559 1.01947 6.07136 1.12322 6.55115 1.33073C7.03095 1.53824 7.45208 1.82357 7.81456 2.18674C8.17704 2.54991 8.46199 2.97192 8.66941 3.45278C8.87682 3.93364 8.98053 4.44842 8.98053 4.99713C8.98053 5.5464 8.87678 6.06267 8.66927 6.54594C8.46177 7.02921 8.17643 7.45208 7.81326 7.81456C7.4501 8.17704 7.02808 8.46199 6.54722 8.66941C6.06637 8.87682 5.55158 8.98053 5.00288 8.98053Z" fill="#1C1B1F"/></g>
            </svg>
            <span class="reason recalled" @click="showReason(item.id)">Recalled</span>
            <div class="modal-recall shape-chat" v-if="showModalReason === item.id">
              <span> {{ item.reason }}</span>
            </div>
          </div>-->
        </div>

        <!-- Show more button -->
        <div class="more-button">
          <button class="button-all-action button-all-primary" @click="filterData()">
            <span>Show more</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import ComboardDetail from '@/views/comboards/comboard/ComboardDetail'
  import ComboardForm from '@/views/comboards/comboard/ComboardForm'
  import Datepicker from '@vuepic/vue-datepicker'
  import VueDatePicker from '@vuepic/vue-datepicker'
  import '@vuepic/vue-datepicker/dist/main.css'
  import LazyYoutube from '@/components/LazyYoutube'
  import JbButton from '@/components/JbButton'
  import RecipientsForm from '@/views/comboards/comboard/RecipientsForm.vue'
  import axios from 'axios'
  import dayjs from 'dayjs'
  import {
    mdiMenuDown,
    mdiClose,
    mdiTrashCan,
    mdiMagnify,
    mdiCircleEditOutline,
    mdiPublish,
    mdiSend,
    mdiCircleSmall,
    mdiArrowDownDropCircle,
    mdiPlusCircleOutline
  } from '@mdi/js'
  import {
    ref,
    reactive,
    onMounted,
    onBeforeMount,
    watchEffect,
    watch,
    defineComponent
  } from 'vue'
  import { useStore } from 'vuex'
  import { useRouter } from 'vue-router'
  import { useToast } from 'vue-toastification'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import ShowImage from '@/components/ShowImage'
  import CryptoJS from 'crypto-js'
  import ShowImage2 from '@/components/showImage2'
  import defaultImg from '@/assets/parent/default.png'
  import { Carousel, Pagination, Slide, Navigation } from 'vue3-carousel'
  import 'vue3-carousel/dist/carousel.css'

  export default defineComponent ({
    name: 'HomeParent',
    components: {
      RecipientsForm,
      VueDatePicker,
      JbButton,
      Loading,
      LazyYoutube,
      ShowImage,
      ShowImage2,
      Datepicker,
      ComboardDetail,
      ComboardForm,
      Carousel,
      Navigation,
      Slide,
      Pagination
    },
    mounted () {
      // this.$refs['lazyVideo'].playVideo();
    },
    props: {
      comment: Object,
      showEdit: {
        Boolean
      },
      propHome: {
        type: Object,
        default: () => ({
          empty: true
        })
      },
      propClass: {
        type: Object,
        default: () => ({
          empty: true
        })
      },
      propChild: {
        type: Object,
        default: () => ({
          empty: true
        })
      },
      propAttach: {
        type: Object,
        default: () => ({
          empty: true
        })
      }
    },
    data: () => ({
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ]
    }),
    emits: ['close-modal', 'submit'],
    setup (props, { emit }) {
      const str = useStore()

      const toast = useToast()

      const errors = ref([])

      const router = useRouter()

      const isLoading = ref(false)

      const dataReason = ref(false)

      const slides = reactive([])

      const titleStack = ref(['Admin', 'Forms'])

      const idValueComment = ref()
      const idValueChild = ref()
      const commentClickId = ref()

      const homeObject = ref({})
      const childObject = ref({})
      const comboardObject = ref({})
      const recipientsObject = ref({})

      const userLogin = localStorage.getItem('name')
      const userRole = localStorage.getItem('roles')
      const usernameLogin = localStorage.getItem('username')

      const detailModal = ref(false)

      const comboardModal = ref(false)

      const deleteModal = ref(false)

      const detailChild = ref(false)

      const childModal = ref({})

      const showEdit = ref(false)

      const showModalReason = ref('test')

      const deleteComboards = ref()

      const recipientsModal = ref(false)

      const detailInfo = (ids) => {
        homeObject.value = ids
        getBase64(ids)
      }

      const showModalComboard = () => {
        comboardModal.value = !comboardModal.value
      }

      const showModalRecipients = () => {
        recipientsModal.value = true
      }

      const addComboard = () => {
        showModalComboard()
        showEdit.value = false
        comboardObject.value = comboards
      }

      const hideModalRecipients = () => {
        recipientsModal.value = false
      }

      const hideModalComboard = () => {
        comboardModal.value = false
        refreshComboard()
      }

      const addRecipientsSoon = (ids) => {
        showModalRecipients()
        // recipientsObject.value = comboardObject.value
        value.id = ids
        value.comboard_id = ids
        comboardObject.value = value
        recipientsObject.value = value
      }

      const addRecipients = (value, ids) => {
        showModalRecipients()
        value.id = ids
        value.comboard_id = ids
        recipientsObject.value = value
      }

      const commentObject = reactive([])

      const showDetail = (value, ids) => {
        value.id = ids
        value.comboard_id = ids
        comboardObject.value = value
        commentObject.value = ids
        detailModal.value = true

        // console.log("cek detail ges", comboardObject.value, commentObject.value, detailModal.value)
      }

      const editData = (value, ids) => {
        showEdit.value = true
        value.id = ids
        value.comboard_id = ids
        comboardObject.value = value
        showModalComboard()
      }

      const deletePost = (value) => {
        showModal()
        deleteComboards.value = value
        comboards.detail_delete = 'header'
      }

      const deletePostComment = (value) => {
        showModal()
        deleteComboards.value = value
        comboards.detail_delete = 'comment'
      }

      const hideModal = () => {
        deleteModal.value = false
        refreshComboard()
      }

      const showReason = (index) => {
        dataReason.value = index
        if(showModalReason.value !== index){
          showModalReason.value = index
        } else {
          showModalReason.value = 'test'
        }
      }

      const showModal = () => {
        deleteModal.value = !deleteModal.value
      }

      const confirm = () => {
        if (comboards.detail_delete === 'header') {
          confirmDelete()
        } else {
          confirmDeleteComment()
        }
      }

      const checkUser = ref(false)
      const userCheck = async () => {
        const decryptedMessage = CryptoJS.AES.decrypt(localStorage.getItem('role'), 'amatra1609').toString(CryptoJS.enc.Utf8)
        const myArray = decryptedMessage.split(',')
        for (let i = 0; i < myArray.length; i++) {
          if (myArray[i] === 'ROLE_ADMIN' || myArray[i] === 'ROLE_ADMIN_HRD') {
            checkUser.value = true
          }
        }
      }

      const cancel = () => (deleteModal.value = false)
      const confirmDelete = () => {
        isLoading.value = true
        axios
          .delete(`comboard-detail/${deleteComboards.value}`)
          .then(response => {
              if (response.data.success) {
              rowData = rowData.filter(item => item.id !== deleteComboards.value);
              comboardData.value = rowData;
              searchData.value = comboardData.value;
              comboards.skip = 0
              comboards.page = 1
              // refresh()
              refreshComboard()
              hideModal()
              isLoading.value = false
              toast.success(response.data.message, {
                timeout: 5000
              })
            } else {
              isLoading.value = false
              toast.error(response.data.message, { timeout: 5000 })
            }
          }).catch(error => {
            isLoading.value = false
            console.log(error)
          })
      }

      const confirmDeleteComment = async () => {
        isLoading.value = true
        const url = 'deletecomment'
        const method = 'POST'
        await axios({
            method,
            url,
            params: {
              id: deleteComboards.value
            }
          })
          .then(response => {
            if (response.data.success) {
              refresh2()
              hideModal()
              isLoading.value = false
              toast.success(response.data.message, {
                timeout: 5000
              })
            } else {
              isLoading.value = false
              toast.error(response.data.message, { timeout: 5000 })
            }
          }).catch(error => {
            isLoading.value = false
            console.log(error)
          })
      }

      const filter = reactive({
        dates: '',
        month: '',
        year: '',

        datesCom: '',
        monthCom: '',
        yearCom: ''
      })

      const search = reactive({
        title: '',
      })

      const comboards = reactive({
        id: '',
        show_date: '',
        comboard_category_id: '',
        info: '',
        is_event: '',
        datetime_1: '',
        datetime_2: '',
        to_parent: '',
        to_teacher: '',
        to_student: '',
        add_to_calendar: '',
        is_recalled: '',
        recall_time: '',
        reason: '',
        created_by: '',
        updated_by: '',
        link_url: '',
        show_id: '',
        show_detail_id: '',
        detail_delete: '',
        skip: 0,
        page: 1,
        checkpage: 1,
        title: ''
      })

       const reset = () => {
        commentParent.comment_input = []
       }

       const filterData = () => {
        comboards.skip = 5 * comboards.page
        comboards.page = comboards.page + 1
        refresh()
      }

      const commentParent = reactive({
        id: '',
        show_date: '',
        comboard_category_id: '',
        info: '',
        is_event: '',
        datetime_1: '',
        datetime_2: '',
        to_parent: '',
        to_teacher: '',
        to_student: '',
        add_to_calendar: '',
        is_recalled: '',
        recall_time: '',
        reason: '',
        name: '',
        comment: '',
        comment_input: [],
        created_by: '',
        updated_by: '',
        created_at: ''
      })

      const comment2 = reactive({
        id: '',
        comboard_id: '',
        parent_comment_id: '',
        comment: '',
        created_by: '',
        updated_by: ''
      })

      // Child
      const parentChild = reactive({
        id: '',
        comboard_id: '',
        parent_comment_id: '',
        comment: '',
        comment_detail: [],
        reply_detail: [],
        reply_head: [],
        name: '',
        created_by: '',
        updated_by: '',
        detail_id: ''
      })

      const parentChild2 = reactive({
        id: '',
        comboard_id: '',
        parent_comment_id: '',
        comment: '',
        created_by: '',
        updated_by: '',
        detail_id: ''
      })

      const comboardData = reactive([])

      const comboardMonth = reactive([])
      const comboardYear = reactive([])
      const comboardDate = reactive([])

      const searchData = reactive([])
      const value = reactive({
        user_parent_id: '',
        month: '',
        year: '',
        date: '',
        skip: '',
        search: ''
      })

      const tempoData = reactive([])
      const loadingComboard = ref(false)
      const refreshComboard = async (monthFilter, yearFilter, fillDate) => {
        loadingComboard.value = true
        const user_parent = localStorage.getItem('user_id')
        const role = localStorage.getItem('roles')
        const url = 'comboard-admin'
        const method = 'GET'
        await axios({
            method,
            url,
            params: {
              user_parent_id: user_parent,
              month: monthFilter,
              year: yearFilter,
              date: fillDate,
              skip: comboards.skip,
              roles: role
            }
          })
          .then(response => {
            tempoData.value = response.data.data
            comboardData.value = tempoData.value
            searchData.value = comboardData.value

            comboardMonth.value = comboardData.value.filter(item => item.month === monthFilter)
            comboardYear.value = comboardData.value.filter(item => item.year === yearFilter)
            comboardDate.value = comboardData.value.filter(item => item.date === fillDate)

            isLoading.value = false
            loadingComboard.value = false
          })
          .catch(error => {
             // toast.error(error.response.data, { timeout: 5000 })
            console.log(error)
            isLoading.value = false
            loadingComboard.value = false
          })
      }

      let rowData = []
      const refresh = async () => {
        // isLoading.value = true
        loadingComboard.value = true
        const user_parent = localStorage.getItem('user_id')
        const role = localStorage.getItem('roles')
        const url = 'comboard-admin'
        const method = 'GET'
        await axios({
            method,
            url,
            params: {
              user_parent_id: user_parent,
              month: filter.monthCom,
              year: filter.yearCom,
              date: filter.datesCom,
              skip: comboards.skip,
              roles: role
            }
          })
          .then(response => {
            if (response.data.data.length > 0) {
            const jdiSatu = response.data.data.map((newItem) => {
              const comboardAdmin = rowData.find((item) => item.id === newItem.id);
              return comboardAdmin ? { ...comboardAdmin, ...newItem } : newItem;
            });

            rowData = [...rowData.filter((item) => !jdiSatu.find((newItem) => newItem.id === item.id)),...jdiSatu,];
            comboardData.value = rowData;
            searchData.value = comboardData.value;
          }
            // comboardMonth.value = comboards.value.filter(item => item.month === monthString)
            // comboards.value = response.data.data

            if (comboards.skip < 1) {
              refreshComboard()
              commentParent.value = response.data.dataDetail
              parentChild.value = response.data.dataDetail
            }

            comboards.checkpage = response.data.checkisi
            if (comboards.checkpage < 1) {
              alert('Semua data sudah ditampilkan')
            }
            // isLoading.value = false
            loadingComboard.value = false
          })
          .catch(error => {
             // toast.error(error.response.data, { timeout: 5000 })
             isLoading.value = false
             loadingComboard.value = false
             console.log(error)
          })
      }

      // Detail
      const refresh2 = async () => {
        isLoading.value = true
        const user_parent = localStorage.getItem('user_id')
        const url = 'comment-parent'
        const method = 'GET'
        await axios({
            method,
            url,
            params: {
              user_parent_id: user_parent,
              comboard_id: idValueComment.value
            }
          })
          .then(response => {
            commentParent.value = response.data.data
            // Child
            parentChild.value = response.data.data

            isLoading.value = false
          })
          .catch(error => {
            // toast.error(error.response.data, { timeout: 5000 })
            console.log(error)
            isLoading.value = false
          })
      }

      const attachment = reactive({
        id: '',
        comboard_id: '',
        file_1: ''
      })

      const getBase64 = async (attach) => {
        await axios
          .get('/comboard-attachment', {
            params: {
              comboard_id: attach,
              download: true
            }
          })
          .then(response => {
            attachment.value = response.data.data
          })
      }

      // Input Comment Parent
      const store = async (index, env) => {
        const url = props.showEdit ? 'comboard-detail/' + commentParent.id : 'comboard-detail'
        const method = props.showEdit ? 'PUT' : 'POST'
        if (method === 'POST') {
          commentParent.created_by = localStorage.getItem('username')
        } else {
          commentParent.updated_by = localStorage.getItem('username')
        }

        const dataSubmit = reactive({
          name: userLogin,
          comment: commentParent.comment_input[env],
          comboard_id: index,
          created_by: localStorage.getItem('username')
        })

        await axios({
          method,
          url,
          params: dataSubmit
        })
        .then(response => {
          if (response.data.success) {
            toast.success(response.data.message)
            refresh2()
            reset()
          } else {
            errors.value = response.data.messages
            toast.error(response.data.messages)
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error)
            toast.error(error.response.message)
            console.log(JSON.stringify(error.request))
          } else if (error.message) {
            console.log(error.message)
            toast.error(error.message)
            console.log(JSON.stringify(error.message))
          }
        })
      }

      // Input Comment Child
      const store2 = async (index, cid) => {
        const url = props.showEdit ? 'comboard-detail/' + parentChild.id : 'comboard-detail'
        const method = props.showEdit ? 'PUT' : 'POST'
        if (method === 'POST') {
            parentChild.created_by = localStorage.getItem('username')
        } else {
            parentChild.updated_by = localStorage.getItem('username')
        }

        const dataChildSubmit = reactive({
          comboard_id: cid,
          comment: parentChild.comment_detail[index],
          name: userLogin,
          created_by: localStorage.getItem('username'),
          detail_id: index,
          reply: parseInt(parentChild.reply_detail[index]) + 1,
          head_id: parentChild.reply_head[index]
        })

        // parentChild.name = userLogin
        // parentChild.reply = parseInt(parentChild.reply_detail[index]) + 1
        // parentChild.comment = parentChild.comment_detail[index]
        // parentChild.comboard_id = cid
        // parentChild.detail_id = index
        // parentChild.head_id = parentChild.reply_head[index]

        // parentChild.comboard_id = homeObject.value

        parentChild.id = parentChild2.id

        await axios({
        method,
        url,
        params: dataChildSubmit
        })
        .then(response => {
          if (response.data.success) {
            toast.success(response.data.message)
            refresh2()
          } else {
            errors.value = response.data.messages
            toast.error(response.data.messages)
          }
          parentChild.comment_detail[index] = ''
        })
        .catch(error => {
          if (error.response) {
              console.log(error)
              toast.error(error.response.message)
              console.log(JSON.stringify(error.request))
          } else if (error.message) {
              console.log(error.message)
              toast.error(error.message)
              console.log(JSON.stringify(error.message))
          }
        })
      }

      const showComment = (index) => {
        commentClickId.value = index
      }

      const hideModal2 = () => {
        detailChild.value = false
        // refresh2()
      }

      const showModal2 = () => {
        detailChild.value = !detailChild.value
      }

      const addChild = (item) => {
        showModal2()
        childObject.value = item
      }

      const role = async () => {
        const user_parent = localStorage.getItem('user_id')
        await axios
          .get('comboard-role', {
            params: {
              user_parent_id: user_parent
            }
          })
          .then(response => {
            localStorage.setItem('roleComboard', response.data.data)
          })
          .catch((error) => {
            toast.error(error.data.message)
          })
      }

      const checkUserLogin = async () => {
        // isLoading.value = true
        const user = localStorage.getItem('user_id')
        const loginAs = 'administrator'
        const url = 'check-user-login'
        const method = 'GET'
        await axios({
          method,
          url,
          params: {
            user_id: user,
            login_as: loginAs
          }
        })
        .then(response => {
          if(response.data.data < 1){
            // localStorage.clear()
            router.push('/login')

            // isLoading.value = false
          }
        })
        .catch(error => {
          console.log('error user', error)
          // localStorage.clear()
          router.push('/login')
          // isLoading.value = false
        })
      }

      onMounted(() => {
        checkUserLogin()

        if (localStorage.getItem('reloaded')) {
          localStorage.removeItem('reloaded')
        } else {
          localStorage.setItem('reloaded', '1')
          // location.reload()
        }
        userCheck()

        comboards.skip = 0
        comboards.page = 1
        refresh()
        // refreshComboard()

        // months()

        // setTimeout(() => {
        //   refresh2()
        // }, 2000)
      })

      onBeforeMount(() => {})

      watch(() => value.search, (newVal, oldVal) => {
          if (value.search.trim().length >0) {
              comboardData.value =  tempoData.value.filter(item =>
                  (item.title != null && item.title.toLowerCase().includes(value.search.trim().toLowerCase())) ||
                  (item.info != null && item.info.toLowerCase().includes(value.search.trim().toLowerCase()))
              )
          } else {
              comboardData.value =  tempoData.value
          }
      })

      watch(() => filter.month, (newVal, oldVal) => {
        const newMonth = newVal ? newVal.month : null;
        const oldMonth = oldVal ? oldVal.month : null;

        if(newMonth !== oldMonth || (newMonth === '' && oldMonth !== '')){
          // Month
          const monthFilter = newMonth !== null ? (newMonth + 1).toString().padStart(2, '0') : '';

          // Year
          const yearFilter = filter.year ? filter.year.toString() : '';

          // Date
          let fillDate = ''
          if (newVal !== null) {
            const date = new Date(filter.dates);
            if (!isNaN(date)) {
              const months = (date.getMonth() + 1).toString().padStart(2, '0');
              const day = date.getDate().toString();
              const year = date.getFullYear().toString();
              const fillDate = `${year}-${months}-${day}`
              filter.datesCom = fillDate
            } else {
              filter.datesCom = '';
            }
          } else {
            filter.datesCom = '';
          }

          filter.monthCom = monthFilter
          filter.yearCom = yearFilter

          refreshComboard(monthFilter, yearFilter, fillDate)
        } else if (newMonth === '' && oldMonth !== '') {
          filter.month = null;
        }
      })

      watch(() => filter.year, (newVal, oldVal) => {
        if (newVal !== undefined && newVal !== null) {
          // Month
          let month = newVal.month;
          month += 1;
          const monthFilter = month.toString().padStart(2, '0');

          // Year
          const yearFilter = filter.year.toString();

          // Date
          let fillDate = ''
          if (newVal !== null) {
            const date = new Date(filter.dates);
            if (!isNaN(date)) {
              const months = (date.getMonth() + 1).toString().padStart(2, '0');
              const day = date.getDate().toString();
              const year = date.getFullYear().toString();
              const fillDate = `${year}-${months}-${day}`
              filter.datesCom = fillDate
            } else {
              filter.datesCom = '';
            }
          } else {
            filter.datesCom = '';
          }

          filter.monthCom = monthFilter
          filter.yearCom = yearFilter

          refreshComboard(monthFilter, yearFilter, fillDate)
        }
      })

      watch(() => filter.dates, (newVal, oldVal) => {
        if (newVal !== undefined && newVal !== null) {
          const yearFilter = filter.year.toString();

          const date = new Date(filter.dates);
          const months = (date.getMonth() + 1).toString().padStart(2, '0');
          const day = date.getDate().toString();
          const year = date.getFullYear().toString();
          const fillDate = `${year}-${months}-${day}`

          let month = filter.month.month;
          month += 1;
          const monthFilter = month.toString().padStart(2, '0');

          filter.monthCom = monthFilter
          filter.yearCom = yearFilter
          filter.datesCom = fillDate

          refreshComboard(monthFilter, yearFilter, fillDate)
        }
      })

      watchEffect(() => {
        const newComments = commentObject.value
        const id = newComments
        idValueComment.value = id
        Object.assign(comment2, newComments)
        refresh2()

        const newChild = childObject.value
        const id1 = newChild.id
        idValueChild.value = id1
        Object.assign(parentChild2, newChild)
      })

      const showid = (item, value) => {
        let num = value
        if (value === null) {
          num = 0
        }
        parentChild.reply_detail[item] = num
        if (comboards.show_id === item) {
          comboards.show_id = ''
        } else {
          comboards.show_id = item
        }
      }
      const showdetailid = (item, value, data) => {
        // showModal()
        deleteComboards.value = value
        let num = value
        if (value === null) {
          num = 0
        }
        parentChild.reply_detail[item] = num
        parentChild.reply_head[item] = data
        if (comboards.show_detail_id === item) {
          comboards.show_detail_id = ''
        } else {
          comboards.show_detail_id = item
        }
      }
            // Download File
      const download = (name, url, id) => {
        // UNCOMMENT JIKA EDU TIDAK MENGGUNKAKAN DOC-MANAGEMENT
        const data = {
          filename: name,
          id: id
        }
        axios
          .get(url, {
            params: data,
            responseType: 'blob'
          })
          .then((response) => {
            // assign state kelass with response data
            const fileURL = window.URL.createObjectURL(new Blob([response.data]))
            const fileLink = document.createElement('a')
            fileLink.href = fileURL
            fileLink.setAttribute('download', name)
            document.body.appendChild(fileLink)
            fileLink.click()
          })
          .catch((error) => {

            console.log(error)
            // toast.error(error.response.data, { timeout: 5000 })
            downloadDoc(name, url, id)
          })
      }
      const downloadDoc = (name, url, id) => {
        // UNCOMMENT JIKA EDU MENGGUNKAKAN DOC-MANAGEMENT
        const data = {
          filename: name,
          id: id
        }
        axiosDocument
          .get('download-comboard', {
            params: data,
            responseType: 'blob'
          })
          .then((response) => {
            // assign state kelass with response data
            const fileURL = window.URL.createObjectURL(new Blob([response.data]))
            const fileLink = document.createElement('a')
            fileLink.href = fileURL
            fileLink.setAttribute('download', name)
            document.body.appendChild(fileLink)
            fileLink.click()
          })
          .catch((error) => {
            // toast.error(error.response.data, { timeout: 5000 })
            console.log('ERROR', error)
          })
      }

      const openText = ref('none')
      const hideMore = ref(true)
      const showText = (id) => {
        if((openText.value === 'none') || (openText.value != id)) {
          openText.value = id
        } else {
          openText.value = 'none'
        }
      }

      const formatShortDate = (index) => {
        console.log('index', index)
        const date = dayjs(index)
        return date.format('DD MMM YYYY')
      }

      const mobFilter = ref(false)
      const showMobFilter = () => {
        if(mobFilter.value === false) {
          mobFilter.value = true
        } else {
          mobFilter.value = false
        }
      }

      const showbtn = ref(false)
      const openPreAction = reactive({})
      const showActBtn = (data) => {
        if(data) {
          const key = data.replace(/-/g, '')

          if(key) {
            const isCurrentlyOpen = openPreAction[key] === true

            for (const k in openPreAction) {
              openPreAction[k] = false
            }

            openPreAction[key] = !isCurrentlyOpen
          }
        }
      }


      return {
        checkUserLogin,
        refresh,
        showbtn,
        showActBtn,
        addRecipientsSoon,
        commentObject,
        tempoData,
        value,
        searchData,
        search,
        showModalRecipients,
        addRecipients,
        recipientsObject,
        recipientsModal,
        hideModalRecipients,
        editData,
        showDetail,
        showModalComboard,
        addComboard,
        hideModalComboard,
        comboardObject,
        comboardModal,
        showEdit,
        comboardMonth,
        comboardYear,
        comboardDate,
        comboardData,
        filter,
        showReason,
        showModalReason,
        dataReason,
        role,
        showid,
       // modaladd,
        filterData,
        showdetailid,
        mdiArrowDownDropCircle,
        mdiPlusCircleOutline,
        mdiMenuDown,
        mdiClose,
        mdiTrashCan,
        mdiMagnify,
        mdiCircleEditOutline,
        mdiPublish,
        mdiSend,
        mdiCircleSmall,
        titleStack,
        comboards,
        openPreAction,
        detailModal,
        deletePost,
        deletePostComment,
        deleteModal,
        hideModal,
        hideModal2,
        childModal,
        showModal,
        detailInfo,
        addChild,
        formatShortDate,
        homeObject,
        childObject,
        str,
        // reset,
        store,
        store2,
        reset,
        toast,
        errors,
        router,
        comment2,
        commentParent,
        parentChild,
        parentChild2,
        rowData,
        slides,
        isLoading,
        commentClickId,
        showComment,
        getBase64,
        confirm,
        cancel,
        confirmDelete,
        confirmDeleteComment,
        attachment,
        userLogin,
        usernameLogin,
        checkUser,
        userCheck,
        userRole,
        download,
        downloadDoc,
        openText,
        hideMore,
        showText,
        defaultImg,
        showMobFilter,
        mobFilter,
        loadingComboard
      }
    },
    methods: {
      clearForm () {
        this.attachment = reactive({
          id: '',
          comboard_id: '',
          file_1: '',
          created_at: '',
          created_by: '',
          updated_at: '',
          updated_by: ''
        })
      },
      // input (e) {
      //   const value = e.currentTarget.value;
      //   this.submit.disabled = false
      //   if (value === '') {
      //     this.submit.
      //   }
      // },
      logOutput (outputData) {
      },
      handleClick (event, ref) {
        this.$refs[ref][event]()
      },
      handleSearch (e, platform) {
        if (platform === 'youtube') {
          this.youtubeLink = e.target.value
        } else {
          this.vimeoLink = e.target.value
        }
      }
    }
  })
</script>

<style lang="scss">
  @import '../../src/css/comboardAdmin.scss';
</style>
